import { render } from "./ReportVersion7.vue?vue&type=template&id=910ffe86&scoped=true&ts=true"
import script from "./ReportVersion7.vue?vue&type=script&lang=ts"
export * from "./ReportVersion7.vue?vue&type=script&lang=ts"

import "./ReportVersion7.vue?vue&type=style&index=0&id=910ffe86&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910ffe86"]])

export default __exports__